import { EffectCallback, useEffect } from 'react'
import debounce from 'lodash/debounce'

function useDebouncedEffect(effect: EffectCallback, delay: number, deps: Array<any> = []) {
    useEffect(() => {
        // Create a debounced version of the effect function
        const debouncedEffect = debounce(effect, delay)

        // Execute the debounced effect whenever the dependencies change
        debouncedEffect()

        // Cleanup: Cancel the debounced effect when the component unmounts
        return () => debouncedEffect.cancel()
    }, deps)
}

export default useDebouncedEffect
